module.exports = __webpack_public_path__ + "static/media/3DPPA9.d235ad53.jpg";